import { EditGuesser } from "@api-platform/admin";
import {MedicalCaseForm} from "../components/MedicalCaseForm";

export const MedicalCaseEdit = props => (
<EditGuesser {...props}>
    <MedicalCaseForm />
</EditGuesser>
);
